export default [
  {
    field: "name",
    method: "isEmpty",
    validWhen: false,
    message: "",
  },
  {
    field: "address",
    method: "isEmpty",
    validWhen: false,
    message: "",
  },
  {
    field: "zone",
    method: "isEmpty",
    validWhen: false,
    message: "",
  },
  {
    field: "description",
    method: "isEmpty",
    validWhen: false,
    message: "",
  },
  {
    field: "coordinator",
    method: "isEmpty",
    validWhen: false,
    message: "",
  },
];
